import React, { useEffect } from "react";
import CartNotification from "components/navbar/top/CartNotification";
import ProfileDropdown from "components/navbar/top/ProfileDropdown";
import { Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import MultiSelect from "components/common/MultiSelect";
import ThemeControlDropdown from "./ThemeControlDropdown";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { handleSelectedBU } from "components/config/HeaderSlice";
import { useNavigate } from "react-router-dom";
import { hideLoader, showLoader } from "../../../config/loaderManager.js";
const TopNavRightSideNavItem = () => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.auth);
  const { loginedBranch, buSearch } = useSelector((state) => state.header);
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch"
  );

  const allBranches = JSON.parse(localStorage.getItem("branch_settings"));
  const { control, watch, setValue } = useForm({
    defaultValues: {
      branch: userData?.employee?.branch_default?.branch_id || "",
      default_branch: false,
    },
  });
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const navigate = useNavigate();
  useEffect(() => {
    if (buSearch) {
      setValue("branch", selectedBranch); // set the branch field by buSearch.value
    }
  }, [buSearch, setValue]);
  useEffect(() => {
    if (userData?.employee?.branch_default?.branch_id) {
      const isDefaultBranch =
        selectedBranch?.value === userData.employee.branch_default.branch_id ||
        selectedBranch?.branch_id ===
        userData.employee.branch_default.branch_id;
      setValue("default_branch", isDefaultBranch);
    }
  }, [userData, watch("branch"), setValue]);

  const allowedBranchIds = userData?.employee?.branch_id
    ? userData?.employee?.branch_id
      ?.toString()
      ?.split(",")
      ?.map((id) => Number(id.trim()))
    : [];

  const filteredBranches = allBranches?.filter((branch) =>
    allowedBranchIds.length > 0
      ? allowedBranchIds.includes(Number(branch.branch_id))
      : true
  );

  const branchOptions =
    filteredBranches?.map((branch) => ({
      value: branch.branch_id,
      label: branch.branch_name,
      branch_cchi: branch.branch_cchino,
    })) || [];
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <div className="zoom-80">
        <OverlayTrigger
          placement="bottom"
          show={Number(branchSetting?.list) !== 1 ? undefined : false}
          overlay={
            <Tooltip id="branch-disabled-tooltip-nav">
              You don't have permission to switch branches
            </Tooltip>
          }
        >
          <div>
            <Controller
              name="branch"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  size="sm"
                  options={branchOptions}
                  placeholder="Choose..."
                  className="w-250"
                  classNamePrefix="react-select"
                  disabled={Number(branchSetting?.list) !== 1}
                  value={
                    branchOptions.find(
                      (option) =>
                        option.value === selectedBranch?.branch_id ||
                        option.value === selectedBranch?.value
                    ) || selectedBranch
                  }
                  // ✅ Show both branch_cchi and branch_name
                  formatOptionLabel={(option) => (
                    <div className="d-flex align-items-center">
                      <div>
                        <strong>{`(${option.branch_cchi})`}</strong>
                      </div>
                      <div className="text-muted fs-10">{`- ${option.label}`}</div>
                    </div>
                  )}
                  onChange={(selected) => {
                    field.onChange(selected?.value);

                    dispatch(
                      handleSelectedBU({
                        check: "search",
                        value: selected,
                      })
                    );

                    // ✅ Show loader before navigating
                    showLoader();

                    const isDefault =
                      selected?.value ===
                      userData?.employee?.branch_default?.branch_id;
                    setValue("default_branch", isDefault);

                    // ✅ Delay redirect to allow loader to show (optional)
                    setTimeout(() => {
                      window.location.href = "/";
                    }, 1500); // 1.5 second delay
                  }}
                />
              )}
            />
          </div>
        </OverlayTrigger>
      </div>
      <ThemeControlDropdown />
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
